// extracted by mini-css-extract-plugin
export default {"backHeaderContainer":"FavoriteEvents_backHeaderContainer--GGV","emptySpaceContainer":"FavoriteEvents_emptySpaceContainer--lZf","userLoader":"FavoriteEvents_userLoader--feN"};